module.exports = __webpack_public_path__ + "img/coordinate.79ea06cb.png";